module.exports = __webpack_public_path__ + "static/IMG_2301-c095e70e71b9d8c27c0c764d1ef064d0.jpg";